module.exports = __webpack_public_path__ + "static/img/2.17f7d82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/online/2.jpg
// module id = Al4e
// module chunks = 0